import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import type { IBudget, IPage } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getAveragedPriorFiscalYearsBudget = async (params: {
  fiscalYears: number[];
  fiscalMonth: number;
  facilityIds?: string[];
  serviceTypes?: string[];
  adjustment?: number;
}) => {
  const queryParams: Record<string, any> = {
    fiscalYears: params.fiscalYears,
    fiscalMonth: params.fiscalMonth,
  };

  if (params.facilityIds && params.facilityIds.length > 0)
    queryParams.facilityIds = params.facilityIds;

  if (params.serviceTypes && params.serviceTypes.length > 0)
    queryParams.serviceTypes = params.serviceTypes;

  if (params.adjustment) queryParams.adjustment = params.adjustment;

  return await getRequest(
    `${API_BASE_PATHS.BUDGETS}/averagedBudgetForFiscalYears`,
    queryParams,
  );
};

export const getBudgets = async (
  params?: DataQueryParams,
): Promise<IPage<IBudget>> =>
  await getRequest(API_BASE_PATHS.BUDGETS, formatQueryParams(params));

export const getFiscalYears = async (): Promise<Array<number>> =>
  await getRequest(`${API_BASE_PATHS.BUDGETS}/fiscalyears`);

export const getBudget = async (id: string): Promise<IBudget> =>
  await getRequest(`${API_BASE_PATHS.BUDGETS}/${id}`);

export const addBudget = async (body: any) =>
  await postRequest(API_BASE_PATHS.BUDGETS, {}, body);

export const updateBudget = async (id: string, body: any) =>
  await patchRequest(`${API_BASE_PATHS.BUDGETS}/${id}`, {}, body);

export const deleteBudget = async (id: string) =>
  await deleteRequest(`${API_BASE_PATHS.BUDGETS}/${id}`, {});
